import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {SettingsDevelopersPagesEnum, SettingsDevelopersUrl} from '../../../models/url/settingsUrlModel';
import {AppState} from '../../../store/appState';
import {getApiTokens} from '../../../store/data/dataSelectors';
import {getLocalApplications} from '../../../store/data/localApplications/localApplicationsSelectors';
import {
  getIsSettingsLocalApplicationAsyncStatus,
  getIsSettingsLocalApplicationLoading,
  getSettingsTokensAsyncStatus,
} from '../../../store/panels/settings/settingsPanelSelectors';
import {SettingsDevelopersHeaderTitle} from './settingsDevelopersHeaderTitle';

/*
 * Props.
 */

interface SettingsDevelopersHeaderTitleContainerProps {
  url: SettingsDevelopersUrl;
}

/*
 * Selectors.
 */

function getUrl(_state: AppState, props: SettingsDevelopersHeaderTitleContainerProps) {
  return props.url;
}

const getApplication = createSelector([getUrl, getLocalApplications], (url, applications) => {
  if (
    url.subPage === SettingsDevelopersPagesEnum.APPLICATIONS ||
    url.subPage === SettingsDevelopersPagesEnum.TOKENS
  ) {
    return undefined;
  }
  return applications[url.applicationId];
});

const getToken = createSelector([getUrl, getApiTokens], (url, tokens) => {
  if (url.subPage !== SettingsDevelopersPagesEnum.TOKENS || !url.tokenId) {
    return undefined;
  }
  return tokens[url.tokenId];
});

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsDevelopersHeaderTitleContainerProps>()(() => ({
  application: getApplication,
  token: getToken,
  isApplicationLoading: getIsSettingsLocalApplicationLoading,
  applicationAsyncStatus: getIsSettingsLocalApplicationAsyncStatus,
  tokensAsyncStatus: getSettingsTokensAsyncStatus,
}));

export const SettingsDevelopersHeaderTitleContainer = connect(mapStateToProps)(SettingsDevelopersHeaderTitle);
